export type StageStartAssignmentFields = {
  workstation_id?: string | null;
  assigned_to_user_id?: string | null;
  inspector_user_id?: string | null;
  verifier_user_id?: string | null;
};

const LABELS = [
  { key: 'workstation_id' as const, label: 'Workstation' },
  { key: 'assigned_to_user_id' as const, label: 'Operator' },
  { key: 'inspector_user_id' as const, label: 'Inspector' },
  { key: 'verifier_user_id' as const, label: 'Verifier' },
];

export function missingStageStartAssignmentLabels(stage: StageStartAssignmentFields): string[] {
  const missing: string[] = [];
  for (const { key, label } of LABELS) {
    if (!String(stage[key] ?? '').trim()) missing.push(label);
  }
  return missing;
}

export function hasRequiredStageStartAssignments(stage: StageStartAssignmentFields): boolean {
  return missingStageStartAssignmentLabels(stage).length === 0;
}

/** Message when Start is blocked; null when assignments are complete. */
export function stageStartAssignmentsRequiredMessage(stage: StageStartAssignmentFields): string | null {
  const missing = missingStageStartAssignmentLabels(stage);
  if (!missing.length) return null;
  return `Select Workstation, Operator, Inspector, and Verifier before starting. Missing: ${missing.join(', ')}`;
}
